import React from 'react';
import styled from 'styled-components';
import { BrandFooter } from 'components/atoms/BrandFooter';
import HyattBrandFlag from 'assets/hyatt-brand-flag';
import HyattBanner from 'assets/hyatt-banner';
import { PointEligibleProgram } from '@kouto/types';

const BrandFlagMap: Record<string, React.ReactNode> = {
  FIND: <HyattBrandFlag scale={3} />,
};

const StyledBrandFlagContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

const BrandFlagWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 16px;
  z-index: 50;
`;

interface BrandFlagContainerProps {
  brandFlagName?: string | null;
  children: React.ReactNode;
}

const BrandFlagContainer = ({
  brandFlagName,
  children,
}: BrandFlagContainerProps) => {
  return (
    <StyledBrandFlagContainer>
      <BrandFlagWrapper>
        {brandFlagName && BrandFlagMap[brandFlagName]}
      </BrandFlagWrapper>
      {children}
      {brandFlagName === PointEligibleProgram.FIND && (
        <BrandFooter>
          <HyattBanner />
        </BrandFooter>
      )}
    </StyledBrandFlagContainer>
  );
};

export default BrandFlagContainer;
